/**************** PHONE FORMATTER ****************/

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

import { CountryConfig } from 'src/lib/country.utils'
import { formatSsnString } from 'src/lib/ssn.utils'
import { parseDateOfBirth } from 'src/validations'

// Extend dayjs with UTC plugin
dayjs.extend(utc)

/**************** DATE FORMATTER ****************/

// Example: 12022020 -> 12/02/2020
export const formatDate = async (key, e, form) => {
  const value = e.target.value
  let numbers = value.replace(/\D/g, '')
  if (numbers.length > 8) {
    numbers = numbers.slice(0, 8)
  }
  const char = { 2: '/', 4: '/' }
  let formattedValue = ''
  for (let i = 0; i < numbers.length; i++) {
    formattedValue += (char[i] || '') + numbers[i]
  }

  // new Date('02/31/1990') rolls into March, so a parsed timestamp is not
  // enough. The typed month and day have to exist on the calendar.
  const dateIsValid = parseDateOfBirth(formattedValue) !== null

  const result =
    formattedValue.length === 10 && dateIsValid
      ? new Date(formattedValue)
      : formattedValue

  await form.setFieldValue(key, result)

  // Set custom error if date is invalid and fully entered
  if (formattedValue.length === 10 && !dateIsValid) {
    form.setFieldError(key, 'Invalid date, MM/DD/YYYY')
  } else if (formattedValue.length > 0 && formattedValue.length < 10) {
    // Clear any previous errors while user is still typing
    form.clearFieldError(key)
  }
}

// Example: Date() -> 12/02/2020 (in UTC)
export const formatDateString = (value) => {
  //check if value is a date
  if (value instanceof Date) {
    return dayjs(value).utc().format('MM/DD/YYYY')
  } else {
    return value
  }
}

// Example: Date() -> 12/2020 (in UTC)
export const formatMonthString = (value) => {
  //check if value is a date
  if (value instanceof Date) {
    return dayjs(value).utc().format('MM/YYYY')
  } else {
    return value
  }
}

// Example: 122020 -> 12/2020
export const formatMonthYear = async (key, e, form) => {
  const value = e.target.value
  let numbers = value.replace(/\D/g, '')
  if (numbers.length > 6) {
    numbers = numbers.slice(0, 6)
  }
  const char = { 2: '/' }
  let formattedValue = ''
  for (let i = 0; i < numbers.length; i++) {
    formattedValue += (char[i] || '') + numbers[i]
  }

  const date = formatMonthYearToDate(formattedValue)
  const dateIsValid = date && !isNaN(date.getTime())

  const result =
    formattedValue.length === 7 && dateIsValid ? date : formattedValue

  await form.setFieldValue(key, result)
}

// Example: 12/2020 -> Date(12/01/2020)
export const formatMonthYearToDate = (value) => {
  const formattedDate = value
    ? value.split('/')[0] + '/01/' + value.split('/')[1]
    : undefined
  const result = formattedDate ? new Date(formattedDate) : undefined
  return result
}

/**************** SSN FORMATTER ****************/

// Example: 123456789 -> 123-45-6789
export const formatSsn = async (issuingCountry, ssn, form) => {
  const value = ssn
  let numbers = value.replace(/\D/g, '')
  if (issuingCountry === CountryConfig.US.code && numbers.length > 9) {
    numbers = numbers.slice(0, 9)
  } else if (issuingCountry === CountryConfig.MX.code && numbers.length > 11) {
    numbers = numbers.slice(0, 11)
  }

  const formattedValue = formatSsnString(issuingCountry, numbers)

  await form.setFieldValue('ssn', formattedValue)
  await form.setFieldValue('issuingCountry', issuingCountry)
}
